module.exports = __webpack_public_path__ + "img/Container.bb5e2ee4.png";